/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Search1Inputs */

const id_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const ms_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari`)
};

const da_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg`)
};

const de_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen`)
};

const en_us2_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const es_es2_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const es_mx2_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const fil_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap`)
};

const fr_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const it_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const hu_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés`)
};

const nl_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken`)
};

const no_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk`)
};

const pl_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj`)
};

const pt_br2_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar`)
};

const pt_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const ro_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Căutare`)
};

const fi_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae`)
};

const sv_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök`)
};

const vi_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

const tr_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ara`)
};

const cs_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat`)
};

const bg_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене`)
};

const ru_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск`)
};

const uk_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук`)
};

const ar_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بحث`)
};

const hi_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज`)
};

const th_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหา`)
};

const ja_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索`)
};

const zh_cn2_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索`)
};

const zh_hant1_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋`)
};

const ko_offerdetail_changelog_search1 = /** @type {(inputs: Offerdetail_Changelog_Search1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검색`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Offerdetail_Changelog_Search1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_search1 = /** @type {((inputs?: Offerdetail_Changelog_Search1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Search1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_search1(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_search1(inputs)
	if (locale === "da") return da_offerdetail_changelog_search1(inputs)
	if (locale === "de") return de_offerdetail_changelog_search1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_search1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_search1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_search1(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_search1(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_search1(inputs)
	if (locale === "it") return it_offerdetail_changelog_search1(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_search1(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_search1(inputs)
	if (locale === "no") return no_offerdetail_changelog_search1(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_search1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_search1(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_search1(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_search1(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_search1(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_search1(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_search1(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_search1(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_search1(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_search1(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_search1(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_search1(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_search1(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_search1(inputs)
	if (locale === "th") return th_offerdetail_changelog_search1(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_search1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_search1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_search1(inputs)
	return ko_offerdetail_changelog_search1(inputs)
});
export { offerdetail_changelog_search1 as "offerDetail.changelog.search" }